import React from 'react';
import styled, { css } from 'styled-components';
import SbEditable from 'storyblok-react';

import Components from '../components';

const HeaderVariantB = (props) => {
  return (
    <SbEditable content={props.blok}>
      <ContainerBgImage
        bgImage={props.blok.bg_image?.filename}
        bgFixed={props.blok.bg_image_fixed}
        navSafeZone={props.blok.navigation_safe_zone}
      >
        <Container
          safeZone={props.blok.safe_zone}
          height={props.blok.height}
          desktopAlign={props.blok.desktop_block_alignment}
          textColor={props.blok.default_text_color}
          bgOverlay={props.blok.bg_overlay}
          bgOverlayColor={props.blok.bg_overlay_color.color}
          bgOverlayOpacity={props.blok.bg_overlay_opacity}
        >
          <MobileHeading>
            {props.blok.heading_content?.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          </MobileHeading>
          <Block desktopOrder={props.blok.block_a_desktop} mobileOrder={props.blok.block_a_mobile}>
            <DesktopHeading>
              {props.blok.heading_content?.map((blok) =>
                React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
              )}
            </DesktopHeading>
            {props.blok.block_a_content.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          </Block>
          <Block desktopOrder={props.blok.block_b_desktop} mobileOrder={props.blok.block_b_mobile}>
            {props.blok.block_b_content.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          </Block>
        </Container>
      </ContainerBgImage>
    </SbEditable>
  );
};

const getRgbFromHex = (hex) => {
  const result = /^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/.exec(hex);

  if (!result) {
    return { r: 0, g: 0, b: 0 };
  }

  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  };
};

const pctToFloat = (pct) => {
  const val = /^(\d+)%/.exec(pct);

  if (!val) {
    return 0.0;
  }

  return val[1] / 100;
};

const ContainerBgImage = styled.div`
  background-position: center;
  background-size: cover;
  ${(props) =>
    props.bgFixed &&
    css`
      background-attachment: fixed;
    `}
  ${(props) =>
    props.bgImage &&
    css`background-image: url('${props.bgImage}');`}
  @media screen and (max-width: 768px) {
    ${(props) =>
      props.navSafeZone &&
      css`
        padding-top: 60px;
      `}
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;

  ${(props) =>
    css`
      min-height: ${props.height};
    `}
  ${(props) =>
    css`
      padding: ${props.safeZone};
    `}
  ${(props) =>
    css`
      color: ${props.textColor};
    `}
  ${(props) =>
    props.bgOverlay &&
    css`
      background-color: rgba(
        ${getRgbFromHex(props.bgOverlayColor).r},
        ${getRgbFromHex(props.bgOverlayColor).g},
        ${getRgbFromHex(props.bgOverlayColor).b},
        ${pctToFloat(props.bgOverlayOpacity)}
      );
    `}

  @media screen and (min-width: 769px) {
    ${(props) =>
      css`
        align-items: ${props.desktopAlign};
      `}
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const Heading = styled.h1`
  font-family: 'Gotham Black';
  font-weight: normal;
  margin-bottom: 1rem;
`;

const MobileHeading = styled.div`
  display: none;
  margin-bottom: 1rem;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const DesktopHeading = styled.div`
  display: block;
  margin-bottom: 1rem;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Block = styled.div`
  width: 100%;
  ${(props) =>
    props.desktopOrder &&
    css`
      order: ${props.desktopOrder};
    `}
  ${(props) =>
    props.mobileOrder &&
    css`
      @media screen and (max-width: 768px) {
        order: ${props.mobileOrder};
      }
    `}
`;

export default HeaderVariantB;
